import React, { useState, useEffect } from "react";
import {
  CCard,
  CCardHeader,
  CCardBody,
  CNavLink,
  CCardText,
  CImage,
  CRow,
  CCol,
  CButton,
} from "@coreui/react-pro";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";
import { getHotels } from "../../../BackendFirebase/getHotelsfromFirebase";
import MapHotels from "./MapHotels";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";

const apiKey = "AIzaSyB85oa264g0eIIr0sCpzQw1Q0fXNjr7wzQ";

const defaultZoom = 11;
const defaultCenter = { lat: -33.8915, lng: 151.2767 };

const MarkerWithInfoWindow = ({
  hotel,
  isOpen,
  onToggleOpen,
  handleBookShowerClick,
}) => {
  const navigate = useNavigate();
  const position = { lat: hotel.Hotel_Latitude, lng: hotel.Hotel_Longitude };

  return (
    <Marker
      onClick={onToggleOpen}
      position={position}
      title={hotel.Hotel_Description}
      label={{
        text: hotel.Hotel_Description.slice(0, 1),
      }}
      icon={{
        url: hotel.Shower_Room_Availability
          ? "http://maps.google.com/mapfiles/ms/icons/green.png"
          : "http://maps.google.com/mapfiles/ms/icons/red.png",
      }}
    >
      {isOpen && (
        <InfoWindow onCloseClick={onToggleOpen}>
          <CCard style={{ width: "auto", minWidth: "300px" }}>
            <CRow>
              <CCol xs="12" sm="5">
                <CImage
                  src={hotel.Shower_Room_Picture}
                  alt={hotel.Hotel_Description}
                  style={{ width: "100%", height: "auto", objectFit: "cover" }}
                />
              </CCol>
              <CCol xs="12" sm="7">
                <CCardHeader>{hotel.Hotel_Description}</CCardHeader>
                <CCardBody>
                  <CCardText>{hotel.Hotel_Location}</CCardText>
                  <CNavLink>
                    <CButton
                      color="primary"
                      onClick={() => handleBookShowerClick(hotel)}
                    >
                      Book Shower
                    </CButton>
                  </CNavLink>
                </CCardBody>
              </CCol>
            </CRow>
          </CCard>
        </InfoWindow>
      )}
    </Marker>
  );
};

const GoogleMapsComponent = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: apiKey,
    version: "weekly",
    language: "en",
  });

  const { hotels, handleBookShowerClick } = useHotelData();
  const [openMarker, setOpenMarker] = useState(null);

  return (
    isLoaded && (
      <>
        <GoogleMap
          mapContainerStyle={{ height: `400px`, width: "100%" }}
          center={defaultCenter}
          zoom={defaultZoom}
          keyboardShortcuts={true}
        >
          {hotels.map((hotel, index) => (
            <MarkerWithInfoWindow
              key={hotel.Hotel_ID.toString()}
              hotel={hotel}
              isOpen={openMarker === index}
              onToggleOpen={() =>
                setOpenMarker(openMarker === index ? null : index)
              }
              handleBookShowerClick={handleBookShowerClick}
            />
          ))}
        </GoogleMap>
        <div style={{ marginTop: "1rem" }}>
          <h5>Legend:</h5>
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "#32CD32",
                width: "1rem",
                height: "1rem",
                marginRight: "0.5rem",
              }}
            ></div>
            <p className="mb-0">Open for Shower Room Reservations</p>
          </div>
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "#FF5A00",
                width: "1rem",
                height: "1rem",
                marginRight: "0.5rem",
              }}
            ></div>
            <p className="mb-0">No Availability Currently</p>
          </div>
        </div>
      </>
    )
  );
};

const useHotelData = () => {
  const navigate = useNavigate();
  const [hotels, setHotels] = useState([]);

  const handleBookShowerClick = (hotel) => {
    if (hotel.Shower_Room_Availability) {
      navigate(`/book-shower/${hotel.Hotel_Description}`);
    } else {
      toast.error("Unfortunately, No No Availability Currently!");
    }
  };

  useEffect(() => {
    const fetchHotels = async () => {
      const fetchedHotels = await getHotels();
      fetchedHotels.sort((a, b) => a.Hotel_ID - b.Hotel_ID);
      console.log("Fetched hotels:", fetchedHotels);
      setHotels(fetchedHotels);
    };
    fetchHotels();
  }, []); // Empty array as dependency to only run once
  return { hotels, handleBookShowerClick };
};

const HotelList = () => {
  const { hotels } = useHotelData();
  const navigate = useNavigate();

  return (
    <div>
      {hotels.map((hotel) => (
        <div key={hotel.Hotel_ID} style={{ marginBottom: "1rem" }}>
          <CCard>
            <CRow>
              <CCol xs="12" sm="5">
                <CImage
                  src={hotel.Shower_Room_Picture}
                  alt={hotel.Hotel_Description}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />
              </CCol>
              <CCol xs="12" sm="7">
                <CCardHeader>{hotel.Hotel_Description}</CCardHeader>
                <CCardBody>
                  <CCardText>{hotel.Hotel_Location}</CCardText>
                  <CNavLink>
                    <CButton
                      color="primary"
                      onClick={() => handleBookShowerClick(hotel)}
                    >
                      Book Shower
                    </CButton>
                  </CNavLink>
                </CCardBody>
              </CCol>
            </CRow>
          </CCard>
        </div>
      ))}
    </div>
  );
};

const Map = () => {
  return (
    <div className="animated fadeIn">
      <MapHotels />
    </div>
  );
};

export { GoogleMapsComponent };
export { useHotelData };
export default Map;
